// The grid is not virtualised, so past this it is a page that takes a second to lay out and stutters as it scrolls.
// Only what is drawn is capped — the line above the table still counts every row the document holds.
export const MAX_ROWS = 1000;

// A cell too long to be a cell: the grid clips it rather than the browser laying out a paragraph inside a row.
const MAX_CELL = 500;

export type SortDirection = "asc" | "desc";

// A copy rather than the rows themselves, so the order the document is in survives the order it is being read in.
export function sortRows(rows: string[][], at: number, direction: SortDirection): string[][] {
  const sign = direction === "asc" ? 1 : -1;
  return [...rows].sort((first, second) => sign * compareCells(first[at] ?? "", second[at] ?? ""));
}

// Every cell is text, and a column of prices sorted as text puts 9.99 above 12.50 — so two cells that are both
// numbers are compared as numbers, and everything else the way the reader's own locale orders words.
export function compareCells(first: string, second: string): number {
  const left = Number(first);
  const right = Number(second);
  if (first !== "" && second !== "" && !Number.isNaN(left) && !Number.isNaN(right)) return left - right;
  return first.localeCompare(second);
}

// A row shorter than the widest one is missing its last fields rather than holding empty ones, and a cell that is
// not there reads exactly like one that is empty.
export function cellText(row: string[], at: number): string {
  const value = row[at] ?? "";
  return value.length > MAX_CELL ? `${value.slice(0, MAX_CELL)}…` : value;
}
